import { CheckmarkCircleIcon } from '@datacamp/waffles-icons';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var thanksStyle = {
  alignItems: 'center',
  display: 'flex',
  flexBasis: '100%',
  justifyContent: 'center'
};

var ThanksForRating = function ThanksForRating(_ref) {
  var ratedMessage = _ref.ratedMessage;
  return ___EmotionJSX("div", {
    style: thanksStyle
  }, ___EmotionJSX(CheckmarkCircleIcon, {
    className: "dc-u-mr-4"
  }), ___EmotionJSX("p", {
    className: "dc-u-m-4"
  }, ratedMessage));
};

export default ThanksForRating;